export default new class LazyVideo {
    init(){
        const lazyVideos = [].slice.call(document.querySelectorAll("video.js-lazy-video"));
        if ("IntersectionObserver" in window) {
            let lazyVideoObserver = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        let lazyVideo = entry.target;
                        lazyVideo.querySelectorAll('source').forEach(source => {
                            source.src = source.dataset.src;
                        })
                        entry.target.load();

                        lazyVideo.classList.add('js-lazy-video--active');
                        lazyVideo.classList.remove("js-lazy-video");
                        lazyVideoObserver.unobserve(lazyVideo);
                    }
                });
            },
            {
                rootMargin: "200px",
            });

            lazyVideos.forEach(lazyVideo => {
                lazyVideoObserver.observe(lazyVideo);
            });
        }
    }
}